var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-between mb-4"},[_c('div',[_c('p',{staticClass:"titulo-medio"},[_vm._v(_vm._s(_vm.$t(_vm.title)))])]),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }